import { Card } from 'react-bootstrap';
import styled from 'styled-components';

export const CardHome = styled(Card)`
  height: 30vh;
  justify-content: center;
  align-items: center;
  align-content: center;
  flex-direction: row;
`;
